export default {
	admin: '后台',
	adminLogin: '登录',
	home: '首页',
	loading: 'Loading...',
	noPower: '无访问权限',
	notFound: '页面找不到了',
	noTitle: '无标题',
	user: '会员中心',
	userLogin: '会员登录',
}
